import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import StepTracker from '@tds/core-step-tracker';
import DimpleDivider from '@tds/core-dimple-divider';

const ProgressBar = ({ name, steps, currentStep }) => {
  const progressSteps = steps.map(item => _.get(item, 'fields.name', ''));
  return (
    <>
      <div>
        <div id="title">
          <div id="title-wrapper">
            <div style={{ paddingTop: '2em' }}>
              <h2>
                <div id="title-label">{name}</div>
              </h2>
              <div id="title-anchors" style={{ marginTop: '10px' }} />
            </div>
          </div>
        </div>
        {steps && steps.length > 1 && (
          <StepTracker
            copy="en"
            current={currentStep - 1}
            steps={progressSteps}
          />
        )}
      </div>
      <DimpleDivider />
    </>
  );
};

ProgressBar.propTypes = {
  name: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

ProgressBar.defaultProps = {
  currentStep: 0
};

export default ProgressBar;
